import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChronosSharedModule } from 'chronos-shared';

@NgModule({
  declarations: [],
  imports: [CommonModule, ChronosSharedModule]
})
export class SpeedMonitorMyMachineModule {}
